import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DecimalPipe],
  selector: 'ui-badge-losses-indicator',
  template: `
    <ng-container>
      <div class="w-full flex justify-end">
        <div
          class="flex flex-row items-center justify-center w-fit gap-x-2 px-3 rounded-full {{
            backgroundColor()
          }} text-black"
        >
          <span
            class="py-1 text-xs min-w-max flex gap-x-0.5 justify-end items-end"
          >
            {{ value() | number: '1.0-2' : 'es' }}
            <span class="text-xs leading-1">{{ units() }}</span>
          </span>
          @if (!!percentage()) {
            <div class="w-0.5 h-7 bg-amber-400"></div>
            <span class="py-1 text-xs min-w-5">
              {{ percentage() | number: '1.0-2' : 'es' }}%
            </span>
          }
        </div>
      </div>
    </ng-container>
  `,
})
export class BadgeLossesIndicatorComponent {
  value = input<number>(0);
  percentage = input<number>(0);
  units = input<string>();
  backgroundColor = input<string>('bg-gray-100');
}
